import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/13. 방글라데시 1공장.bdab828af43cded405b0.jpg`;
const Factory2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/14. 방글라데시 2공장.548ced9a1a4130edf444.jpg`;
const Hat1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/15. 방글라데시 모자1.fd46a2b77eb67dc242b0.png`;
// const Hat2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/16. 방글라데시 모자2.ba918d722bce33c908ef.png`;
import Hat2 from "../../assets/ProductionCorporation2/방글라데시 모자2.png";
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const ProductionCorporation2 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} ename={"YoungAn Hat"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/ProductionCorporation">
                <div className="kor">직경영사업장</div>
                <div className="eng">Direct Management Affiliates</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
          <S.Nav height={"160px"}>
            <S.NavItem>
              <Link to="/HatBusiness/ProductionCorporation2">
                <div className="kor">방글라데시법인</div>
                <div className="eng">Bangladesh company</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">베트남법인</div>
                  <div className="eng">Vietnam company</div></Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation2">
                  <div className="kor">방글라데시법인</div>
                  <div className="eng">Bangladesh company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation3">
                  <div className="kor">스리랑카법인</div>
                  <div className="eng">Sri Lanka company</div>
                </Link>
              </S.NavItem>
              
              
              {/* <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation4">
                  <div className="kor">인도네시아법인</div>
                  <div className="eng">Indonesia company</div>
                </Link>
              </S.NavItem> */}
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"방글라데시 법인"} titleeng={"Bangladesh company"}/>
            <div className="page-text">
              <div className="kor"><h2>방글라데시 법인 / YoungAn Hat(BD) Ltd. YoungAn Int'l(BD) Ltd</h2></div>
              <div className="eng"><h2>Bangladesh company / YoungAn Hat(BD) Ltd. YoungAn Int'l(BD) Ltd.</h2></div>
            </div>

            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory1} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">방글라데시 1공장</div>
                  <div className="eng">Bangladesh Factory 1</div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">방글라데시 2공장</div>
                  <div className="eng">Bangladesh Factory 2</div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>

            <PageTitle titleko={"주요생산제품"} titleeng={"Major Production Products"}/>
            <S.ImgHolderFlex className="center">
              <img src={Hat1} alt="" />
              <img src={Hat2} alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요이력"} titleeng={"Major History"} />

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor"><h2>YoungAn Hat(BD) Ltd. 법인개요</h2></div>
                    <div className="eng"><h2>Company Profile of YoungAn Hat(BD) Ltd.</h2></div>
                    
                  </div>
                  <div className="kor">법인 설립: 1989년 12월 27일</div>
                  <div className="eng">Establishment : Dec. 27th, 1989</div>
                  
                </div>
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor"><h2>YoungAn Int'l(BD) Ltd. 법인개요</h2></div>
                    <div className="eng"><h2>Company Profile of YoungAn Int'l(BD) Ltd.</h2></div>
                    
                  </div>
                  <div className="kor">법인 설립: 2009년 12월 28일</div>
                  <div className="eng">Establishment : Dec. 28th, 2009</div>
                  
                </div>
              </div>
              <div className="kor">※ 중가 대량오다 생산공장
                <br />
                ※ 월마트 등 커스터머 자수캡 위주 생산 / 야구모 위주의 대형
                생산공장
                <br />
                ※ 주요 생산 품목 : 베이스볼캡, 바이저, 기능성캡, 롤업 버켓햇
                <br />
                ※ 1공장 - 13라인 / 년 생산캐파 : 720,000 타<br />
                &nbsp;&nbsp;&nbsp;&nbsp;2공장 - 18라인 / 년 생산캐파 : 960,000 타</div>
              <div className="eng">※ Mid-priced Bulk order production factory <br />
                ※ Production of embroidery cap for custom orders such as Walmart <br />
                &nbsp;&nbsp;&nbsp;&nbsp;/Large production factory that produces mainly baseball caps <br />
                ※ Major Production Products : Baseball cap, Visor, Functional cap, Roll-up bucket hat <br />
                ※ Number of Production Line : Factory 1 - 13 Lines / Yearly Production Capacity : 720,000dz <br />
                &nbsp;&nbsp;&nbsp;&nbsp;Factory 2 - 18 Lines / Yearly Production Capacity : 960,000dz</div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default ProductionCorporation2;
